module.exports = __webpack_public_path__ + "static/media/moonwalker-sharing.d5d3699b.jpg";